import { API_PATHS, PATHS } from 'config/routes'
import { Button, Container, Row } from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import logo from 'assets/images/logo.svg'
import coin from 'assets/images/coin.svg'
import menu from 'assets/images/menu-svgrepo-com.svg'
import avaDefault from 'assets/images/ava-default.jpeg'
import { useQuery } from 'react-query'
import { getUserQuery, useLogin } from 'dataLayer/user'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { curState } from 'store/selector'
import axios from 'axios'
import i18n from 'i18n'
import { reloadHeader } from 'store/actions'
import Drawer from '@material-ui/core/Drawer'
import LeftMenu from '../../../../components/LeftMenu'
import LoginWebModal from 'components/Modal/LoginWebModal'

function HeaderMobile() {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const { data: user, refetch } = useQuery(getUserQuery())
	const [dataUser, setdataUser] = useState(user)
	const selector = useSelector(curState)
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	const location = useLocation()
	const dispatch = useDispatch()
	const [showLeftMenu, setShowLeftmenu] = useState(false)
	const isLoginType = process.env.REACT_APP_IS_LOGIN;
	const [modalShowLoginPass, setModalShowLoginPass] = useState(false)

	useEffect(() => {
		refetch()
	}, [selector.reloadHeader])
	useEffect(() => {
		setdataUser(user)
	}, [user])
	const { mutate: fnLogin, isLoading } = useLogin(
		data => {
			axios.get(API_PATHS.getUser).then(res => {
				const laguageUser = res?.data.data.language
				if (laguageUser) {
					i18n.changeLanguage(laguageUser)
				} else {
					i18n.changeLanguage('la')
				}
			})
			dispatch(reloadHeader(new Date() * 1 + 1))
			navigate(PATHS.HOME_PAGE)
		},
		() => { },
	)
	useEffect(() => {
		if (location.search.includes('authorization_code=')) {
			// let urlCode = location.search
			// let lengthText = urlCode.length - 1
			// const code = urlCode.slice(6)
			let queryString = window.location.search
			const urlParams = new URLSearchParams(queryString)
			const code = urlParams.get('authorization_code')
			console.log(
				'authorization_code:::::',
				urlParams.get('authorization_code'),
			)
			fnLogin({
				grant_type: 'login_with_unitel',
				code: code,
				location: 'ARABICA',
			})
		}
	}, [location.search])
	const handleCloseDrawer = () => event => {
		console.log(event, 'event')
		if (
			event.type === 'keydown' &&
			(event.key === 'Tab' || event.key === 'Shift')
		) {
			return
		}

		setShowLeftmenu(false)
	}

	function openLoginModal() {
		if (isLoginType === "POPUP") {
			setModalShowLoginPass(true);
		} else if (isLoginType === "LINK") {
			window.location.href = `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
		}
	}

	return (
		<Container className="header-mobile" fluid>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<img
					onClick={() => setShowLeftmenu(!showLeftMenu)}
					alt="menu"
					src={menu}
					width="30"
					height="25"
					style={{ marginRight: 10 }}
				/>{' '}
				<Link to={PATHS.HOME_PAGE}>
					<img alt="Logo's website" src={logo} width="95" height="38" />
				</Link>
			</div>

			{dataUser ? (
				<Row className="profile-header">
					<Link to={PATHS.PROFILE_PAGE} className="profile-header__coin">
						<img src={coin} alt="Total coins" />
						<span>{dataUser?.coin}</span>
					</Link>
					<Link to={PATHS.PROFILE_PAGE} className="profile-header__ava">
						<img
							src={dataUser?.avatarImage || avaDefault}
							alt="User's avatar"
							onError={e => {
								e.target.onerror = null
								e.target.src = avaDefault
							}}
						/>
					</Link>
				</Row>
			) : (
				<Link
					style={{ color: 'white' }}
					// to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
					// to={PATHS.LOGIN_PASS_MOBILE}
					onClick={openLoginModal}
				>
					{/* <Button variant="primary">{t('login.login')}</Button> */}
				</Link>
			)}

			<Drawer anchor={'left'} open={showLeftMenu} onClose={handleCloseDrawer()}>
				<div style={{ backgroundColor: 'hsl(207deg 83% 6%)' }}>
					<LeftMenu handleCloseDrawer={handleCloseDrawer} />
				</div>
			</Drawer>

			<LoginWebModal
				modalShowLoginPass={modalShowLoginPass}
				setModalShowLoginPass={setModalShowLoginPass}
			/>
		</Container>
	)
}

export default HeaderMobile
